import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, switchMap } from "rxjs/operators";
import { UserProfileService } from "../../portal/user-profile-api/services/user-profile.service";
import * as UserProfileActions from "./user-profile.actions";

@Injectable()
export class UserProfileEffects{
  initializeAction$;
  constructor(
    private actions: Actions,
    private userProfileService : UserProfileService
    ){
      this.initializeAction$ = createEffect(() => this.actions.pipe(
        ofType(UserProfileActions.InitializeAction),
        switchMap(() => this.userProfileService.getUserProfile()),
        map(profile => UserProfileActions.MergeStateAction({ newState: { currentUserProfile: profile } })),
      ));
    }



}


